import { render, staticRenderFns } from "./MessengerChannelStatusWidget.vue?vue&type=template&id=4cd7c162&scoped=true"
import script from "./MessengerChannelStatusWidget.vue?vue&type=script&lang=js"
export * from "./MessengerChannelStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./MessengerChannelStatusWidget.vue?vue&type=style&index=0&id=4cd7c162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd7c162",
  null
  
)

export default component.exports